import React, { Fragment, useEffect, useState } from "react";
import ConfirmModal from "../Component/Plans/ConfirmModal";
import createActivityDetector from "activity-detector";

// 60000 milliseconds === 1min

const UserIsIdle = ({ duration = 1 }) => {
	const [isIdle, setIsIdle] = useState(false);

	useEffect(() => {
		const activityDetector = createActivityDetector({
			timeToIdle: duration * 60000,
			inactivityEvents: [],
		});
		activityDetector.on("idle", () => setIsIdle(true));
		// activityDetector.on("active", () => setIsIdle(false));
		return () => activityDetector.stop();
	}, []);

	return (
		<Fragment>
			{isIdle && (
				<ConfirmModal
					header={`You have been idle for about ${duration}min`}
					confirmText={"Reload"}
					hideCancelBtn={true}
					hideClose={true}
					confirm={() => window.location.reload()}
				></ConfirmModal>
			)}
		</Fragment>
	);
};

export { UserIsIdle };
